import { aptEnsureLoaded } from "../../apt-ensure-loaded"
import { monitoringStore } from "./_components/monitoring-store"

export const monitoringLoader = async ({ params }) => {
  await aptEnsureLoaded(params)

  monitoringStore.getState().reset()

  await monitoringStore.getState().initialize()
  return null
}
